<template>
  <div>
    <div>
      <el-button size="mini" style="margin-top: 5px" @click="importHouse()">导入房产</el-button>
      <el-button size="mini" v-if="ERP.isPermission(3002004002)" style="margin-top: 5px" @click="search()">查询</el-button>
      <el-button size="mini" v-if="ERP.isPermission(3002004007)" style="margin-top: 5px" @click="dialogRegion()">添加区域</el-button>
      <el-button size="mini" v-if="ERP.isPermission(3002004008)" style="margin-top: 5px" @click="dialogBuilding()">添加大楼</el-button>
      <el-button size="mini" v-if="ERP.isPermission(3002004009)" style="margin-top: 5px" @click="dialogUnit()">添加单元</el-button>
      <el-button size="mini" v-if="ERP.isPermission(3002004001)" style="margin-top: 5px" @click="dialogRoom(0)">添加房产</el-button>
      <el-button size="mini" v-if="ERP.isPermission(3002004005)" style="margin-top: 5px" @click="excel()">导出房产</el-button>
    </div>
    <el-descriptions :column="2" size="mini" border style="margin-top: 8px">
      <el-descriptions-item label="房产">
<!--        <el-input size="mini" v-model="form.houseName" placeholder="输入房产搜索"></el-input>-->
        <el-autocomplete
          style="min-width: 400px;max-width: 100%"
          v-model="form.houseName"
          :fetch-suggestions="querySearchAsyncRoom"
          @select="handleSelect"
          placeholder="请输入房产"
          popper-class="autocomplete-room"
          clearable
        ></el-autocomplete>
      </el-descriptions-item>
      <el-descriptions-item label=""> </el-descriptions-item>
    </el-descriptions>
    <el-table max-height="600px" :data="listData" border style="margin-top: 8px" v-loading="loading">
      <el-table-column label="房产" prop="address" min-width="320"/>
      <el-table-column label="计费面积 " prop="charging" width="120"/>
      <el-table-column label="类型" prop="type" width="100"/>
      <el-table-column label="操作" width="200">
        <template slot-scope="data">
          <el-button v-if="ERP.isPermission(3002004003)" type="text" icon="el-icon-setting" @click="dialogRoom(data.row.id)">修改房产</el-button>
          <el-button v-if="ERP.isPermission(3002004006)" type="text" icon="el-icon-delete" @click="deleteHouse(data.row.id)">删除房产</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination style="float: right; margin-top: 10px; margin-right: 20px" background :small="true" layout="prev, pager, next" :page-size="form.pageSize" :total="totalCount" :current-page.sync="form.page"></el-pagination>
    <el-dialog title="导入文件" :visible.sync="importVisible" width="60%" :before-close="handleCloseImport" v-loading="loading">
      <el-upload :action="url" :before-remove="beforeRemove" :on-success="handleAvatarSuccess" accept=".xls,.xlsx" :limit="1" :on-exceed="handleExceed" :file-list="fileList" :before-upload="beforeAvatarUpload">
        <el-button size="small" type="primary" class="texts">点击上传</el-button>
        <div slot="tip" class="el-upload__tip">
          <p>只能上传xls或xlsx文件，且不超过8M</p>
          <p>新增房产请下载导入模板，如果需要导入修改房产信息，请在列表页面导出需要修改房产，使用导出的文件进行导入</p>
        </div>
      </el-upload>
      <el-button v-if="ERP.isPermission(3002004004)" size="mini" @click="importExcelData">导入文件新增房产</el-button>
      <el-button size="mini" @click="downloadExcel">下载导入新增房产模板</el-button>
      <el-button v-if="ERP.isPermission(3002004010)" size="mini" @click="importExcelData2">导入文件修改房产信息</el-button>
    </el-dialog>

    <!--      添加区域-->
    <Modal v-model="dialogRegionButton" ok-text="保存" width="600" :loading="loadingModal" :mask-closable="false" :mask="false" title="添加区域" @on-ok="addRegion">
      <div>
        <el-form ref="from" :model="regionModel" label-width="auto" size="medium">
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择项目" prop="pindex_id">
                <el-select v-model="regionModel.pindex_id" filterable placeholder="请选择">
                  <el-option v-for="item in pindexList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="区域名称" prop="name">
                <el-input v-model="regionModel.name" placeholder="请输入区域名称"/>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </Modal>

    <!--      添加大楼-->
    <Modal v-model="dialogBuildingButton" ok-text="保存" width="600" :loading="loadingModal" :mask-closable="false" :mask="false" title="添加大楼" @on-ok="addBuilding">
      <div>
        <el-form ref="from" :model="buildingModel" label-width="auto" size="medium">
          <el-form-item label="选择项目" prop="pindex_id">
            <el-select v-model="buildingModel.pindex_id" filterable placeholder="请选择">
              <el-option v-for="item in pindexList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="大楼名称" prop="name">
            <el-input v-model="buildingModel.name" placeholder="请输入大楼名称"/>
          </el-form-item>
          <el-form-item label="区域" prop="name">
            <el-select v-model="buildingModel.regionId" filterable remote clearable reserve-keyword placeholder="可搜索区域名称" :remote-method="searchRegion">
              <el-option v-for="item in regionList" :key="item.house_id" :label="item.ancestor_name" :value="item.house_id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </Modal>

    <!--      添加单元-->
    <Modal v-model="dialogUnitButton" ok-text="保存" width="600" :loading="loadingModal" :mask-closable="false" :mask="false" title="添加单元" @on-ok="addUnit">
      <div>
        <el-form ref="from" :model="unitModel" label-width="auto" size="medium">
          <el-form-item label="选择项目" prop="pindex_id">
            <el-select v-model="unitModel.pindex_id" filterable placeholder="请选择">
              <el-option v-for="item in pindexList" :key="item.id" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="单元名称" prop="name">
            <el-input v-model="unitModel.name" placeholder="请输入单元名称" />
          </el-form-item>
          <el-form-item label="大楼" prop="name">
            <el-select v-model="unitModel.buildingId" filterable remote clearable reserve-keyword placeholder="可搜索大楼名称" :remote-method="searchBuilding">
              <el-option v-for="item in buildingList" :key="item.house_id" :label="item.ancestor_name" :value="item.house_id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </Modal>

    <!--      添加/编辑房间-->
    <Modal v-model="dialogRoomButton" ok-text="保存" width="800" title="添加/编辑房间" @on-ok="addRoom">
      <div>
        <el-form ref="from" label-width="80px" :model="roomModel" :rules="rules">
          <el-row>
            <el-col :span="12">
              <el-form-item label="选择项目" prop="pindex_id">
                <el-select v-model="roomModel.pindex_id" filterable placeholder="请选择">
                  <el-option v-for="item in pindexList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="选择类型" prop="type">
                <el-select v-model="roomModel.type" placeholder="请选择类型">
                  <el-option label="住宅" value="1"></el-option>
                  <el-option label="车位" value="2"></el-option>
                  <el-option label="储藏室" value="3"></el-option>
                  <el-option label="商铺" value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 住宅 -->
          <div v-if="roomModel.type == 1" prop="name">
            <el-form-item label="房间">
              <el-input
                v-model="roomModel.name"
                placeholder="填写房间"
              ></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="8">
                <el-form-item label="建筑面积">
                  <el-input v-model="roomModel.area" placeholder="填写建筑面积"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="套内面积">
                  <el-input v-model="roomModel.dwelling_space" placeholder="填写套内面积"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="计费面积" prop="charging">
                  <el-input v-model="roomModel.charging" placeholder="请填写计费面积"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="花园面积">
                  <el-input v-model="roomModel.garden" placeholder="填写花园面积"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="分摊面积">
                  <el-input v-model="roomModel.share" placeholder="填写分摊面积"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="区域" prop="regionId">
                  <el-select style="width: 100%" v-model="roomModel.regionId" filterable remote clearable reserve-keyword placeholder="可搜索区域名称" :remote-method="searchRegion">
                    <el-option v-for="item in regionList" :key="item.house_id" :label="item.ancestor_name" :value="item.house_id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="大楼">
                  <el-select style="width: 100%" v-model="roomModel.buildingId" filterable remote clearable reserve-keyword placeholder="可搜索大楼名称" :remote-method="searchBuilding">
                    <el-option v-for="item in buildingList" :key="item.house_id" :label="item.ancestor_name" :value="item.house_id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="单元" prop="unitId">
                  <el-select style="width: 100%" v-model="roomModel.unitId" filterable remote clearable reserve-keyword placeholder="可搜索单元名称" :remote-method="searchUnit">
                    <el-option v-for="item in unitList" :key="item.house_id" :label="item.ancestor_name" :value="item.house_id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="8">
                <el-form-item label="楼层" prop="floor">
                  <el-input v-model="roomModel.floor" placeholder="请填写楼层"/>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- 车位 -->
          <div v-if="roomModel.type == 2" prop="name">
            <el-form-item label="车位">
              <el-input v-model="roomModel.name" placeholder="填写车位"></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="8">
                <el-form-item label="计费面积" prop="charging">
                  <el-input v-model="roomModel.charging" placeholder="请填写计费面积"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="停车场" prop="regionId">
                  <el-select style="width: 100%" v-model="roomModel.regionId" filterable remote clearable reserve-keyword placeholder="可搜索停车场名称" :remote-method="searchRegion">
                    <el-option v-for="item in regionList" :key="item.house_id" :label="item.ancestor_name" :value="item.house_id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="车区编号">
                  <el-select style="width: 100%" v-model="roomModel.buildingId" filterable remote clearable reserve-keyword placeholder="可搜索车区编号名称" :remote-method="searchBuilding">
                    <el-option v-for="item in buildingList" :key="item.house_id" :label="item.ancestor_name" :value="item.house_id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="车区分区">
                  <el-select style="width: 100%" v-model="roomModel.unitId" filterable remote clearable reserve-keyword placeholder="可搜索车区分区" :remote-method="searchUnit">
                    <el-option v-for="item in unitList" :key="item.house_id" :label="item.ancestor_name" :value="item.house_id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- 储藏室 -->
          <div v-if="roomModel.type == 3" prop="name">
            <el-form-item label="储藏室">
              <el-input v-model="roomModel.name" placeholder="填写储藏室编号"></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="12">
                <el-form-item label="计费面积" prop="charging">
                  <el-input v-model="roomModel.charging" placeholder="请填写计费面积"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="区域" prop="regionId">
                  <el-select style="width: 100%" v-model="roomModel.regionId" filterable remote clearable reserve-keyword placeholder="可搜索区域名称" :remote-method="searchRegion">
                    <el-option v-for="item in regionList" :key="item.house_id" :label="item.ancestor_name" :value="item.house_id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="大楼">
                  <el-select style="width: 100%" v-model="roomModel.buildingId" filterable remote clearable reserve-keyword placeholder="可搜索大楼名称" :remote-method="searchBuilding">
                    <el-option v-for="item in buildingList" :key="item.house_id" :label="item.ancestor_name" :value="item.house_id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="单元">
                  <el-select style="width: 100%" v-model="roomModel.unitId" filterable remote clearable reserve-keyword placeholder="可搜索单元名称" :remote-method="searchUnit">
                    <el-option v-for="item in unitList" :key="item.house_id" :label="item.ancestor_name" :value="item.house_id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <!-- 商铺 -->
          <div v-if="roomModel.type == 4">
            <el-form-item label="商铺" prop="name">
              <el-input v-model="roomModel.name" placeholder="填写商铺"></el-input>
            </el-form-item>
            <el-row>
              <el-col :span="8">
                <el-form-item label="楼层" prop="floor">
                  <el-input v-model="roomModel.floor" placeholder="填写楼层"/>
                </el-form-item>
              </el-col>
              <el-col :span="8" prop="charging">
                <el-form-item label="计费面积">
                  <el-input v-model="roomModel.charging" placeholder="请填写计费面积"/>
                </el-form-item>
              </el-col>
              <el-col :span="8">
                <el-form-item label="分摊面积">
                  <el-input v-model="roomModel.share" placeholder="填写分摊面积"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="区域" prop="regionId">
                  <el-select style="width: 100%" v-model="roomModel.regionId" filterable remote clearable reserve-keyword placeholder="可搜索区域名称" :remote-method="searchRegion">
                    <el-option v-for="item in regionList" :key="item.house_id" :label="item.ancestor_name" :value="item.house_id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="大楼">
                  <el-select style="width: 100%" v-model="roomModel.buildingId" filterable remote clearable reserve-keyword placeholder="可搜索大楼名称" :remote-method="searchBuilding">
                    <el-option v-for="item in buildingList" :key="item.house_id" :label="item.ancestor_name" :value="item.house_id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item label="单元">
                  <el-select style="width: 100%" v-model="roomModel.unitId" filterable remote clearable reserve-keyword placeholder="可搜索单元名称" :remote-method="searchUnit">
                    <el-option v-for="item in unitList" :key="item.house_id" :label="item.ancestor_name" :value="item.house_id"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </el-form>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "HouseList",
  inject: ['mainObj'],
  data() {
    return {
      listData: [],
      form: {
        houseName: this.mainObj.house_name,
        customerName: "",
        status: "",
        page: 1,
        pageSize: 20,
      },
      importForm: {
        route: "",
      },
      totalCount: 0,
      url: "",
      fileList: [],
      importVisible: false,
      loading: false,
      dialogRoomButton: false,
      rules: {
        name: [
          { required: true, message: "请填写房号/车位号", trigger: "blur" },
        ],
        pindex_id: [{ required: true, message: "请选择项目", trigger: "blur" }],
        type: [{ required: true, message: "请选择房间类型", trigger: "blur" }],
        regionId: [
          { required: true, message: "请选择区域/停车场", trigger: "blur" },
        ],
        floor: [{ required: true, message: "请填写楼层", trigger: "blur" }],
        charging: [
          { required: true, message: "请填写计费面积", trigger: "blur" },
        ],
      },
      roomModel: {
        id: "",
        pindex_id: "",
        name: "",
        gender: "",
        type: "",
        area: "",
        dwelling_space: "",
        charging: "",
        garden: "",
        share: "",
        regionId: "",
        buildingId: "",
        unitId: "",
        floor: "",
      },
      regionList: [],
      buildingList: [],
      pindexList: [],
      unitList: [],
      loadingModal: false,
      dialogRegionButton: false,
      regionModel: {
        name: "",
        pindex_id: "",
      },
      dialogBuildingButton: false,
      buildingModel: {
        pindex_id: "",
        name: "",
        regionId: "",
      },
      dialogUnitButton: false,
      unitModel: {
        pindex_id: "",
        name: "",
        buildingId: "",
      },
      searchPid: 0,
    };
  },
  mounted() {
    const login = window.localStorage.getItem("login");
    const token = window.localStorage.getItem("token");
    this.form.houseName = this.mainObj.house_name;
    this.url =
      this.$myhttp.defaults.baseURL +
      "/admin/excel?" +
      "login_name=" +
      login +
      "&token=" +
      token;
    this.getProjectList();
  },
  watch: {
    'mainObj.project_id': function(n) {
      this.search();
    },
    'mainObj.house_name': function(n) {
      this.form.houseName = n;
    },
    "form.page"(n) {
      this.search();
    },
    "roomModel.pindex_id"(n) {
      this.searchPid = n;
      this.searchRegion("");
      this.searchBuilding("");
      this.searchUnit("");
    },
    "buildingModel.pindex_id"(n) {
      this.searchPid = n;
      this.searchRegion("");
    },
    "unitModel.pindex_id"(n) {
      this.searchPid = n;
      this.searchBuilding("");
    },
  },
  methods: {
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.importData = [];
        })
        .catch(() => {});
    },
    handleAvatarSuccess(res, file) {
      this.importForm.route = file.response[0];
    },
    //超过一个文件
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    //限制大小
    beforeAvatarUpload(file) {
      const isLt7M = file.size / 1024 / 1024 < 8;
      if (!isLt7M) {
        this.$message.error("上传文件大小不能超过 8MB!");
      }
      return isLt7M;
    },
    importHouse() {
      this.importVisible = true;
    },
    handleCloseImport() {
      this.importVisible = false;
    },
    importExcelData() {
      if (this.importForm.route == "") {
        this.$Message.error("文件不能为空!");
        return false;
      }
      this.loading = true;
      this.$myhttp
        .post("admin/house/importHouse", this.importForm, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          this.loading = false;
          // 异步执行成功后
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    search() {
      if (this.mainObj.project_id === 0) {
        this.$message.error("请选择项目");
        return;
      }
      this.form.pid = this.mainObj.project_id;
      this.loading = true;
      this.$myhttp
        .post("admin/house/listHouse", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.listData = backdata.data.data;
            this.totalCount = backdata.data.totalCount;
            this.form.page = backdata.data.page;
            this.loading = false;
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    dialogRoom(id) {
      this.dialogRoomButton = true;
      if (id != 0) {
        this.viewRoom(id);
      } else {
        this.roomModel = {
          id: "",
          pindex_id: "",
          name: "",
          gender: "",
          type: "",
          area: "",
          dwelling_space: "",
          charging: "",
          garden: "",
          share: "",
          regionId: "",
          buildingId: "",
          unitId: "",
          floor: "",
        };
      }
    },
    viewRoom(it) {
      this.$myhttp
        .post(
          "admin/house/viewRoom",
          { id: it },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.roomModel = backdata.data.data;
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    searchRegion(keyword) {
      // let pindex_id = this.roomModel.pindex_id;
      let pindex_id = this.searchPid;
      this.$myhttp
        .post(
          "admin/house/searchRegion",
          { pindex_id, keyword },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.regionList = backdata.data.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    searchBuilding(keyword) {
      // let pindex_id = this.roomModel.pindex_id;
      let pindex_id = this.searchPid;
      this.$myhttp
        .post(
          "admin/house/searchBuilding",
          { pindex_id, keyword },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.buildingList = backdata.data.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    searchUnit(keyword) {
      // let pindex_id = this.roomModel.pindex_id;
      let pindex_id = this.searchPid;
      this.$myhttp
        .post(
          "admin/house/searchUnit",
          { pindex_id, keyword },
          {
            "Content-Type": "application/json",
          }
        )
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.unitList = backdata.data.data;
          }
        })
        .catch((err) => {
          this.$message.error(err);
        });
    },
    // 获得自己名下的所有项目
    getProjectList() {
      this.$myhttp
        .get("admin/common/pindex", {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.data = backdata.data.data.map((item) => {
              return {
                name: item.name,
                id: item.id,
                region: 0,
                type: "project",
                pindex_id: item.id,
                superior: "0",
                projectId: item.id,
              };
            });
            this.pindexList = backdata.data.data.map((item) => {
              return {
                name: item.name,
                id: item.id,
              };
            });
          } else {
            this.$message.error(backdata.data.message);
          }
        });
    },
    // 添加/编辑房间
    addRoom() {
      this.$refs["from"].validate((valid) => {
        if (valid) {
          this.$myhttp
            .post("admin/house/addRoom", this.roomModel, {
              "Content-Type": "application/json",
            })
            .then((backdata) => {
              if (backdata.data.code == 200) {
                this.loadingModals();
                this.$message.success(backdata.data.msg);
                this.search();
                this.dialogRoomButton = false;
              } else {
                this.loadingModals();
                this.$message.error(backdata.data.msg);
                this.dialogRoomButton = false;
              }
            })
            .catch((err) => {
              this.loadingModals();
              this.$message.error(err);
              this.dialogRoomButton = false;
            });
        } else {
          this.loadingModals();
          return false;
        }
      });
    },
    loadingModals() {
      let _this = this;
      _this.loadingModal = false;
      setTimeout(() => {
        _this.loadingModal = true;
      }, 10);
    },
    excel() {
      if (this.mainObj.project_id === 0) {
        this.$message.error("请选择项目");
        return;
      }
      this.form.pid = this.mainObj.project_id;
      ERP.showLoading();
      this.$myhttp
        .post("admin/house/export", this.form, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            let url = window.Glob.BuildErpApi + backdata.data.data;
            ERP.hideLoading();
            window.open("/office.html#/office?url=" + url, "_blank");
          } else {
            this.$message.error(backdata.data.msg);
            ERP.hideLoading();
          }
        })
        .catch((err) => {
          this.$message.error(err);
          ERP.hideLoading();
        });
    },
    importExcelData2() {
      if (this.importForm.route == "") {
        this.$Message.error("文件不能为空!");
        return false;
      }
      this.loading = true;
      this.$myhttp
        .post("admin/house/importEditHouse", this.importForm, {
          "Content-Type": "application/x-www-form-urlencoded",
        })
        .then((backdata) => {
          this.loading = false;
          // 异步执行成功后
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
          } else {
            this.$message.error(backdata.data.msg);
          }
        })
        .catch((err) => {
          this.loading = false;
          this.$message.error(err);
        });
    },
    downloadExcel() {
      let url = window.Glob.BuildErpApi + "/excel/导入房产模板.xlsx";
      window.open("/office.html#/office?url=" + url, "_blank");
    },
    dialogRegion() {
      this.dialogRegionButton = true;
    },
    // 添加区域
    addRegion() {
      if (this.regionModel.pindex_id == "" || this.regionModel.pindex_id == 0) {
        this.$message.error("请选择项目");
        this.loadingModals();
        return false;
      }
      this.$myhttp
        .post("admin/house/addRegion", this.regionModel, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.loadingModals();
            this.$message.success(backdata.data.msg);
            this.data = [];
            this.getProjectList();
            this.dialogRegionButton = false;
          } else {
            this.loadingModals();
            this.$message.error(backdata.data.msg);
            this.dialogRegionButton = false;
          }
        })
        .catch((err) => {
          this.loadingModals();
          this.$message.error(err);
          this.dialogRegionButton = false;
        });
    },
    dialogBuilding() {
      this.dialogBuildingButton = true;
    },
    // 添加大楼
    addBuilding() {
      if (
        this.buildingModel.pindex_id == "" ||
        this.buildingModel.pindex_id == 0
      ) {
        this.$message.error("请选择项目");
        // this.loadingModals();
        return false;
      }
      if (
        this.buildingModel.regionId == "" ||
        this.buildingModel.regionId == 0
      ) {
        this.$message.error("请选择区域");
        return false;
      }
      this.$myhttp
        .post("admin/house/addBuilding", this.buildingModel, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.loadingModals();
            this.$message.success(backdata.data.msg);
            this.data = [];
            this.getProjectList();
            this.dialogBuildingButton = false;
          } else {
            this.loadingModals();
            this.$message.error(backdata.data.msg);
            this.dialogBuildingButton = false;
          }
        })
        .catch((err) => {
          this.loadingModals();
          this.$message.error(err);
          this.dialogBuildingButton = false;
        });
    },
    dialogUnit() {
      this.dialogUnitButton = true;
    },
    // 添加单元
    addUnit() {
      if (this.unitModel.pindex_id == "" || this.unitModel.pindex_id == 0) {
        this.$message.error("请选择项目");
        // this.loadingModals();
        return false;
      }
      if (this.unitModel.buildingId == "" || this.unitModel.buildingId == 0) {
        this.$message.error("请选择大楼");
        return false;
      }
      this.$myhttp
        .post("admin/house/addUnit", this.unitModel, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.loadingModals();
            this.$message.success(backdata.data.msg);
            this.data = [];
            this.getProjectList();
            this.dialogUnitButton = false;
          } else {
            this.loadingModals();
            this.$message.error(backdata.data.msg);
            this.dialogUnitButton = false;
          }
        })
        .catch((err) => {
          this.loadingModals();
          this.$message.error(err);
          this.dialogUnitButton = false;
        });
    },
    deleteHouse(id) {
      this.loading = true;
      this.$myhttp
        .post("admin/house/deleteHouse", {id}, {
          "Content-Type": "application/json",
        })
        .then((backdata) => {
          if (backdata.data.code == 200) {
            this.$message.success(backdata.data.msg);
            this.search();
            this.loading = false;
          } else {
            this.$message.error(backdata.data.msg);
            this.loading = false;
          }
        })
        .catch((err) => {
          this.$message.error(err);
          this.loading = false;
        });
    },
    querySearchAsyncRoom(queryString, cb){
      if(!queryString){
        cb([]);
      }else {
        ERP.postRequest({
          url:"admin/Customer/getHouseList",
          data:{keyWord:queryString}
        },ret=>{
          if(ret.code) {
            cb(ret.data)
          }
        })
      }
    },
    handleSelect(item) {
      this.form.houseName=item.value;
      this.mainObj.house_id=item.id;
      this.mainObj.house_name=item.value;
    },
  },
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/components/house/HouseList.vue